var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgHide(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "14px",
    height: "13px",
    viewBox: "0 0 14 13",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Hide@1x") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Symbols",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "All-Icons",
    transform: "translate(-59.000000, -36.000000)",
    stroke: "#B7844D"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Hide",
    transform: "translate(59.941125, 36.485465)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "View",
    transform: "translate(0.000000, 2.999900)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M6.12806097,0 L6.12193903,0 C1.83658171,0 0,3.49970185 0,3.49970185 C0,3.49970185 1.83658171,7 6.12193903,7 L6.12806097,7 C10.4072964,7 12.25,3.49970185 12.25,3.49970185 C12.25,3.49970185 10.4072964,0 6.12806097,0",
    id: "Path"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Oval",
    strokeWidth: 0.75,
    cx: 6.0588745,
    cy: 3.51463538,
    r: 3.125
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Oval",
    cx: 4.5588745,
    cy: 2.01463538,
    r: 1
  })), /*#__PURE__*/React.createElement("line", {
    x1: 3,
    y1: 0,
    x2: 9.5588745,
    y2: 11.8899616,
    id: "Path-16",
    strokeWidth: 1.2
  }))))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgHide);
export default __webpack_public_path__ + "static/media/Hide.673c298ed0cee475f32a687ea87c7033.svg";
export { ForwardRef as ReactComponent };